import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { State } from '@/types';

import { TLogo } from '../types';

import { logosQueryKeys } from './query-keys';

export type TUpdateLogoImagesParams = {
  id: string;
  main_logo?: File | string;
  logos?: File[] | string[];
  state: State;
};

export async function updateLogoImages(params: TUpdateLogoImagesParams): Promise<TLogo> {
  const formData = new FormData();

  if (params.main_logo instanceof File) {
    formData.append('main_logo', params.main_logo);
  }
  if (params.logos) {
    params.logos
      .filter(logo => logo instanceof File)
      .forEach((logo, index) => {
        formData.append(`logo${index}`, logo);
      });
  }

  return mediaManagerClient.patch(`/api/v1/logos/${params.id}/images`, formData);
}

type MutationFn = typeof updateLogoImages;

type TUseUpdateLogoImagesParams = {
  config?: MutationConfig<MutationFn>;
};

export function useUpdateLogoImage({ config = {} }: TUseUpdateLogoImagesParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: updateLogoImages,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la imagen'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('Se ha actualizado la imagen'));
      queryClient.invalidateQueries({ queryKey: logosQueryKeys.all });
    },
  });
}
